export const CHECKOUT_URL =
  'https://mega-pack-energia-solar-e-instalacion-fotovoltaica.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#oferta'

export const PRICE = '$19.990'
export const BONUS_VALUE = '$116.135'

export const BRAND = 'CM DIGITAL PRO'
export const PRODUCT = 'MEGA PACK ENERGÍA SOLAR E INSTALACIÓN FOTOVOLTAICA'
export const PRODUCT_TM = 'MEGA PACK ENERGÍA SOLAR E INSTALACIÓN FOTOVOLTAICA™'
export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/83o3cFkWsytgVbDxeMKRq6/Imagen_de_Codex_5_sept_2026,_22_16_53.png'

export const ROUTE = [
  'Fundamentos',
  'Componentes',
  'Dimensionamiento',
  'Instalación',
  'Mantenimiento',
  'Emprendimiento',
]

export const questions = [
  '¿Cómo funciona realmente un sistema fotovoltaico?',
  '¿Qué paneles, inversores y baterías se utilizan?',
  '¿Cómo calculo el consumo de una vivienda?',
  '¿Cómo puedo estimar cuántos paneles necesita un proyecto?',
  '¿Qué debo saber antes de una instalación?',
  '¿Y cómo puedo convertir estos conocimientos en una oportunidad profesional?',
]

export const goals = [
  'Comprender cómo funciona la energía solar fotovoltaica.',
  'Reconocer los componentes principales de un sistema.',
  'Interpretar consumos eléctricos básicos.',
  'Realizar estimaciones iniciales de potencia y paneles.',
  'Comprender las etapas generales de una instalación.',
  'Identificar principios de mantenimiento y diagnóstico.',
  'Conocer los primeros pasos para desarrollarte en el sector solar.',
]

export const modules = [
  {
    title: 'MÓDULO 1 — FUNDAMENTOS DE LA ENERGÍA SOLAR FOTOVOLTAICA',
    desc: 'Comprende cómo funciona la energía solar y aprende conceptos esenciales como voltaje, corriente, potencia, energía, Wh, kWh, horas solares pico y las diferencias entre sistemas on-grid, off-grid e híbridos.',
  },
  {
    title: 'MÓDULO 2 — COMPONENTES DEL SISTEMA FOTOVOLTAICO',
    desc: 'Conoce paneles, inversores, controladores, baterías, estructuras, cableado, conectores, protecciones y monitoreo, entendiendo la función de cada elemento.',
  },
  {
    title: 'MÓDULO 3 — CONSUMO Y DIMENSIONAMIENTO BÁSICO',
    desc: 'Aprende a analizar consumos, organizar cargas, interpretar datos básicos y realizar estimaciones educativas de potencia fotovoltaica, cantidad de paneles y almacenamiento.',
  },
  {
    title: 'MÓDULO 4 — DISEÑO E INSTALACIÓN FOTOVOLTAICA',
    desc: 'Descubre cómo se organiza un proyecto desde el relevamiento, orientación y sombras hasta estructuras, ubicación de equipos, conexiones, protecciones, montaje y seguridad.',
  },
  {
    title: 'MÓDULO 5 — MANTENIMIENTO, MONITOREO Y DIAGNÓSTICO',
    desc: 'Aprende a reconocer señales comunes, interpretar información básica del monitoreo, registrar incidencias y comprender principios de mantenimiento preventivo.',
  },
  {
    title: 'MÓDULO 6 — EMPRENDIMIENTO Y SALIDA PROFESIONAL SOLAR',
    desc: 'Descubre cómo comenzar a transformar tus conocimientos en servicios mediante relevamientos, propuestas, presupuestos, seguimiento y búsqueda de oportunidades.',
  },
]

export const bonuses = [
  {
    title: 'BONO 1 — CALCULADORA SOLAR RÁPIDA™',
    desc: 'Organiza consumos y realiza estimaciones preliminares de energía, potencia fotovoltaica, paneles y almacenamiento.',
    value: '$18.099',
  },
  {
    title: 'BONO 2 — CHECKLIST PROFESIONAL DE INSTALACIÓN SOLAR™',
    desc: 'Organiza las etapas de relevamiento, planificación, componentes, seguridad, revisión y entrega de un proyecto.',
    value: '$43.739',
  },
  {
    title: 'BONO 3 — KIT DE PLANTILLAS PARA COTIZAR PROYECTOS SOLARES™',
    desc: 'Utiliza fichas, presupuestos, propuestas comerciales y herramientas de seguimiento para presentar tus servicios profesionalmente.',
    value: '$18.099',
  },
  {
    title: 'BONO 4 — GUÍA VISUAL DE FALLAS Y MANTENIMIENTO FOTOVOLTAICO™',
    desc: 'Reconoce señales comunes, organiza inspecciones visuales, registra incidencias y aprende cuándo solicitar una revisión profesional.',
    value: '$18.099',
  },
  {
    title: 'BONO 5 — PRIMER CLIENTE SOLAR EN 30 DÍAS™',
    desc: 'Sigue una ruta práctica para definir tu servicio, buscar oportunidades, generar contactos, preparar propuestas y realizar seguimiento.',
    value: '$18.099',
  },
]

export const routeSteps = [
  { icon: '☀️', text: 'Empiezas desde cero.' },
  { icon: '⚡', text: 'Comprendes cómo funciona.' },
  { icon: '🔋', text: 'Reconoces sus componentes.' },
  { icon: '📐', text: 'Aprendes a realizar estimaciones básicas.' },
  { icon: '🛠️', text: 'Entiendes instalación y mantenimiento.' },
  { icon: '💼', text: 'Descubres cómo dar tus primeros pasos profesionales.' },
]

export const offerHighlights = [
  'Fundamentos de Energía Solar',
  'Componentes Fotovoltaicos',
  'Consumo y Dimensionamiento',
  'Diseño e Instalación',
  'Mantenimiento y Diagnóstico',
  'Emprendimiento Solar',
]

export const testimonials = [
  {
    name: 'Diego Salazar',
    role: 'Electricista matriculado, 38 años',
    place: 'Córdoba, Argentina',
    text: 'Llevaba doce años haciendo instalaciones eléctricas domiciliarias y perdía trabajos solares porque no sabía dimensionar. El Módulo 3 me ordenó la cabeza: aprendí a leer el consumo de la factura, organizar cargas y estimar potencia y paneles. Con la Calculadora Solar Rápida presenté mi primera propuesta en dos semanas y la cerré.',
  },
  {
    name: 'Javier Mendoza',
    role: 'Técnico en mantenimiento industrial, 31 años',
    place: 'Guadalajara, México',
    text: 'Había visto decenas de videos sueltos y seguía sin entender la diferencia real entre on-grid, off-grid e híbrido. Los Módulos 1 y 2 me explicaron cada componente y su función con diagramas claros. Ahora entiendo qué hace el inversor, el controlador y las protecciones, y puedo hablar con proveedores sin sentirme perdido.',
  },
  {
    name: 'Andrés Villalba',
    role: 'Emprendedor del sector eléctrico, 44 años',
    place: 'Bogotá, Colombia',
    text: 'Yo ya tenía clientes de electricidad, lo que no tenía era una forma profesional de cotizar solar. El Kit de Plantillas y el Módulo 6 me dieron estructura: relevamiento, propuesta, presupuesto y seguimiento. Dejé de improvisar por WhatsApp y mi tasa de respuesta cambió por completo.',
  },
  {
    name: 'Rodrigo Ferreira',
    role: 'Estudiante de electromecánica, 26 años',
    place: 'Montevideo, Uruguay',
    text: 'Empecé desde cero absoluto y lo que más me sirvió fue el orden del recorrido: primero fundamentos, después componentes y recién ahí dimensionamiento. El Checklist de Instalación me permitió acompañar un montaje real entendiendo cada etapa, la orientación, las sombras y la seguridad.',
  },
  {
    name: 'Marcelo Quispe',
    role: 'Instalador independiente, 35 años',
    place: 'Lima, Perú',
    text: 'Lo que me faltaba era la parte de después de la instalación. El Módulo 5 y la Guía Visual de Fallas me enseñaron a reconocer señales comunes, revisar el monitoreo y registrar incidencias. Sumé mantenimiento preventivo como servicio y hoy es mi ingreso más estable del mes.',
  },
]

export const faqs = [
  {
    q: '¿Es un producto físico?',
    a: 'No. Es un producto educativo 100% digital con acceso después de la compra.',
  },
  {
    q: '¿Para quién es?',
    a: 'Para principiantes, electricistas y emprendedores que desean construir una base en energía solar siguiendo una ruta clara y estructurada.',
  },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El recorrido comienza desde los fundamentos y avanza progresivamente.',
  },
  {
    q: '¿Aprenderé a dimensionar sistemas solares?',
    a: 'Aprenderás conceptos y procedimientos educativos para realizar estimaciones básicas de consumo, potencia fotovoltaica, paneles y almacenamiento. Los cálculos definitivos de proyectos reales deben realizarse según las condiciones técnicas y normativas correspondientes.',
  },
  {
    q: '¿Incluye material práctico?',
    a: 'Sí. Encontrarás ejemplos, ejercicios, checklists, calculadoras, plantillas y recursos complementarios.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos están incluidos gratis durante esta oferta.',
  },
  {
    q: '¿Cuánto cuesta el sistema completo?',
    a: 'El precio especial de esta oferta es de $19.990 en un único pago, sin mensualidades y con acceso digital.',
  },
  {
    q: '¿Voy a convertirme automáticamente en instalador profesional?',
    a: 'No. El programa proporciona formación educativa. Determinadas instalaciones pueden requerir capacitación, matrícula, habilitación o profesionales competentes según la normativa aplicable.',
  },
  {
    q: '¿Cómo recibiré el producto?',
    a: 'Obtendrás acceso digital después de completar tu compra.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Puedes contactar a CM DIGITAL PRO en soportescmdigital@gmail.com.',
  },
]

export const purchaseAlerts = [
  { name: 'Daniel Whitmore', city: 'Manchester', country: 'Reino Unido' },
  { name: 'Ryan Callaghan', city: 'Toronto', country: 'Canadá' },
  { name: 'Mason Turner', city: 'Phoenix', country: 'Estados Unidos' },
  { name: 'Jack Bradshaw', city: 'Brisbane', country: 'Australia' },
  { name: 'Callum Reid', city: 'Glasgow', country: 'Reino Unido' },
  { name: 'Lucas Kowalski', city: 'Calgary', country: 'Canadá' },
  { name: 'Ethan Foster', city: 'Austin', country: 'Estados Unidos' },
  { name: 'Liam Hollis', city: 'Perth', country: 'Australia' },
  { name: 'Owen Fletcher', city: 'Birmingham', country: 'Reino Unido' },
  { name: 'Noah Trembley', city: 'Vancouver', country: 'Canadá' },
  { name: 'Caleb Miller', city: 'Denver', country: 'Estados Unidos' },
  { name: 'Harrison Shaw', city: 'Melbourne', country: 'Australia' },
]
